import Cookies from "js-cookie";

const localStoragePrefix = "_highrise_";

function supportsLocalStorage() {
    /* Safari macOS and iOS support localStorage, but it's wonky. Sometimes the values get out of sync. */
    return false;
    // if (!window.localStorage) {
    //     return false;
    // }

    // const key = "__test__";
    // try {
    //     localStorage.setItem(localStoragePrefix + key, "1");
    //     if (localStorage.getItem(localStoragePrefix + key) !== "1") {
    //         return false;
    //     }
    //     localStorage.removeItem(localStoragePrefix + key);
    // } catch (e) {
    //     return false;
    // }

    // return true;
}

function getVal(key) {
    if (supportsLocalStorage()) {
        return localStorage.getItem(key);
    } else {
        return Cookies.get(key);
    }
}

function setVal(key, val) {
    if (supportsLocalStorage()) {
        localStorage.setItem(key, val);
    } else {
        Cookies.set(key, val, { expires: 99999 });
    }
}

function rmVal(key) {
    if (supportsLocalStorage()) {
        localStorage.removeItem(key);
    } else {
        Cookies.remove(key);
    }
}

export function getLocalStorageItem(key) {
    return getVal(localStoragePrefix + key);
}
export function setLocalStorageItem(key, val) {
    setVal(localStoragePrefix + key, val);
}
export function removeLocalStorageItem(key) {
    rmVal(localStoragePrefix + key);
}
